import { Injectable } from "@angular/core";
import { CreateBookingWS } from "@app/core/booking/data/network/create-booking.ws";
import { BookingRepo } from "@app/core/booking/domain/booking-repo";
import { Booking } from "@app/core/booking/domain/model/booking";
import { GetCourtsWS } from "@app/core/court/data/network/get-courts.ws";
import { CourtRepo } from "@app/core/court/domain/court.repo";
import { Court } from "@app/core/court/domain/model/court";

import { Observable, tap } from "rxjs";

@Injectable()
export class CourtDataRepo implements CourtRepo {
  constructor(private getCourtsWS: GetCourtsWS) {}

  getCourts(clubId: string, token: string): Observable<Court[]> {
    return this.getCourtsWS.execute(clubId, token);
  }
}
